import { render, staticRenderFns } from "./CalculatePriceBlockFormat.vue?vue&type=template&id=bfee0666&scoped=true&"
import script from "./CalculatePriceBlockFormat.vue?vue&type=script&lang=js&"
export * from "./CalculatePriceBlockFormat.vue?vue&type=script&lang=js&"
import style0 from "./CalculatePriceBlockFormat.vue?vue&type=style&index=0&id=bfee0666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfee0666",
  null
  
)

export default component.exports